<ul class="list">
    <li class="list-item">
        <button class="filter-btn" [ngClass]="{ active: !letter }" type="button" (click)="selectLetter.emit()">
            all
        </button>
    </li>
    <li *ngFor="let char of ALPHABET" class="list-item">
        <button
            class="filter-btn"
            [ngClass]="{ active: letter === char }"
            type="button"
            (click)="selectLetter.emit(char)"
        >
            {{ char }}
        </button>
    </li>
</ul>
